/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the state of a rollout action.
 */
export type RolloutActionState = 'SCHEDULED' | 'TRIGGERED' | 'FAILED_TO_TRIGGER' | 'CANCELED' | 'RESCHEDULED' | 'EXPIRED';

export const RolloutActionState = {

    SCHEDULED: 'SCHEDULED' as RolloutActionState,

    TRIGGERED: 'TRIGGERED' as RolloutActionState,

    FAILED_TO_TRIGGER: 'FAILED_TO_TRIGGER' as RolloutActionState,

    CANCELED: 'CANCELED' as RolloutActionState,

    RESCHEDULED: 'RESCHEDULED' as RolloutActionState,

    EXPIRED: 'EXPIRED' as RolloutActionState
};

